/* Add-to-bag feedback: a small "Added to your bag" card that slides in under the
   header the moment the button is pressed and leaves on its own after a few
   seconds. The bag drawer stays shut; the button turns into "Go to bag".
   Used by assets/product-form.js through window.AwAdded. */
(() => {
  const SHOW_MS = 3000;
  let card;
  let timer;

  const tick =
    '<svg class="aw-added__icon aw-added__icon--ok" viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10"/><path d="M5.6 10.3l2.9 2.9 5.9-6.2"/></svg>';
  const bang =
    '<svg class="aw-added__icon aw-added__icon--error" viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10"/><path d="M10 5.5v5.6M10 14.2v.3"/></svg>';

  function build() {
    card = document.createElement('div');
    card.className = 'aw-added';
    card.setAttribute('role', 'status');
    card.setAttribute('aria-live', 'polite');
    card.innerHTML = `
      <div class="aw-added__img"></div>
      <div class="aw-added__body">
        <p class="aw-added__head">${tick}${bang}<span class="aw-added__msg"></span></p>
        <p class="aw-added__title"></p>
        <p class="aw-added__meta"></p>
        <button type="button" class="aw-added__view">View bag</button>
      </div>
      <button type="button" class="aw-added__close" aria-label="Close">
        <svg viewBox="0 0 14 14" aria-hidden="true"><path d="M1.5 1.5l11 11M12.5 1.5l-11 11"/></svg>
      </button>
      <span class="aw-added__time" aria-hidden="true"></span>`;
    document.body.appendChild(card);

    card.querySelector('.aw-added__close').addEventListener('click', hide);
    card.querySelector('.aw-added__view').addEventListener('click', openBag);
    // Stays put while someone is reading it
    card.addEventListener('mouseenter', () => clearTimeout(timer));
    card.addEventListener('mouseleave', () => arm(1600));
    card.addEventListener('focusin', () => clearTimeout(timer));
  }

  function openBag() {
    hide();
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.open(document.querySelector('#cart-icon-bubble'));
    else window.location = window.routes.cart_url;
  }

  // Sits just below the header while it is on screen, otherwise at the top
  function place() {
    const header = document.querySelector('.section-header');
    const box = header ? header.getBoundingClientRect() : null;
    const top = box && box.bottom > 0 ? box.bottom + 10 : 10;
    card.style.setProperty('--aw-added-top', `${Math.round(top)}px`);
  }

  function fill(item) {
    const img = card.querySelector('.aw-added__img');
    if (item.image && img.dataset.src !== item.image) {
      img.dataset.src = item.image;
      const photo = new Image(52, 78);
      photo.alt = '';
      photo.src = item.image;
      img.replaceChildren(photo);
    } else if (!item.image && !img.dataset.src) {
      img.innerHTML = '';
    }
    if (item.title) card.querySelector('.aw-added__title').textContent = item.title;
    const meta = card.querySelector('.aw-added__meta');
    if (item.meta !== undefined) {
      meta.textContent = item.meta || '';
      meta.hidden = !item.meta;
    }
  }

  function arm(ms) {
    clearTimeout(timer);
    const bar = card.querySelector('.aw-added__time');
    bar.style.setProperty('--aw-added-ms', `${ms}ms`);
    bar.classList.remove('is-running');
    void bar.offsetWidth;
    bar.classList.add('is-running');
    timer = setTimeout(hide, ms);
  }

  function show(item) {
    if (!card) build();
    clearTimeout(timer);
    card.classList.remove('is-error');
    card.querySelector('.aw-added__img').removeAttribute('data-src');
    card.querySelector('.aw-added__msg').textContent = 'Added to your bag';
    fill(item);
    place();
    // Restart the entrance even if the card is already showing
    card.classList.remove('is-shown');
    void card.offsetWidth;
    card.classList.add('is-shown');
    arm(SHOW_MS);
  }

  // Fills in anything that arrived with the server's answer (e.g. the photo)
  function update(item) {
    if (!card || !card.classList.contains('is-shown') || card.classList.contains('is-error')) return;
    // Keep a photo that's already showing (swapping it would flash an empty box)
    const hasPhoto = Boolean(card.querySelector('.aw-added__img img'));
    fill({ ...item, image: hasPhoto ? undefined : item.image });
  }

  function fail(message) {
    if (!card) build();
    card.classList.add('is-error');
    card.querySelector('.aw-added__msg').textContent = 'Couldn’t add this to your bag';
    card.querySelector('.aw-added__meta').textContent = message || 'Please try again.';
    card.querySelector('.aw-added__meta').hidden = false;
    place();
    card.classList.add('is-shown');
    arm(5000);
  }

  function hide() {
    clearTimeout(timer);
    if (card) card.classList.remove('is-shown');
  }

  // Changes the "BAG (n)" count straight away, with a small pop
  function bump(delta) {
    document.querySelectorAll('.aw-bag__count').forEach((count) => {
      const next = Math.max(0, (parseInt(count.textContent, 10) || 0) + delta);
      count.textContent = next;
      count.classList.remove('is-bumped');
      void count.offsetWidth;
      if (delta > 0) count.classList.add('is-bumped');
    });
  }

  window.AwAdded = { show, update, fail, hide, bump, openBag };

  // Bag note (snippets/aw-bag-offer.liquid): when a code sits in the bag but another
  // discount won, say so: "BEAWARA doesn't combine with Buy 2, save 10%. Your best
  // offer is applied." The bag is re-rendered often, so watch for fresh empty notes.
  let noteTimer;
  const fillCodeNotes = () => {
    const notes = [...document.querySelectorAll('[data-aw-code-note]:not([data-filled])')];
    if (!notes.length) return;
    notes.forEach((n) => n.setAttribute('data-filled', ''));
    fetch(`${window.routes?.cart_url || '/cart'}.js`)
      .then((r) => r.json())
      .then((cart) => {
        const idle = (cart.discount_codes || []).find((d) => !d.applicable);
        // The discount that won: any discount in the bag that isn't one of the codes
        // (Shopify leaves "type" empty for automatic discounts in /cart.js)
        const codes = (cart.discount_codes || []).map((d) => d.code.toUpperCase());
        const rival = [
          ...(cart.cart_level_discount_applications || []),
          ...(cart.items || []).flatMap((i) => (i.line_level_discount_allocations || []).map((a) => a.discount_application)),
        ].find((d) => d && d.title && !codes.includes(d.title.toUpperCase()));
        notes.forEach((n) => {
          if (idle && rival && cart.item_count > 0) {
            n.textContent = `${idle.code} doesn’t combine with ${rival.title}. Your best offer is applied.`;
            n.hidden = false;
          } else {
            n.hidden = true;
          }
        });
      })
      .catch(() => {});
  };
  const watchNotes = () => {
    fillCodeNotes();
    new MutationObserver(() => { clearTimeout(noteTimer); noteTimer = setTimeout(fillCodeNotes, 60); })
      .observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchNotes);
  else watchNotes();

  // Copy buttons for discount codes ([data-aw-copy="CODE"]): used by the sign-up
  // code box (snippets/aw-code.liquid) and the offer ticket on product pages.
  // The button gets .is-copied for a moment; a [data-aw-copy-label] inside it
  // (or the button itself) reads "Copied".
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-aw-copy]');
    if (!button) return;
    const label = button.hasAttribute('data-aw-copy-label') ? button : button.querySelector('[data-aw-copy-label]');
    const copied = () => {
      button.classList.add('is-copied');
      if (label && !label.dataset.awText) label.dataset.awText = label.textContent;
      if (label) label.textContent = 'Copied';
      clearTimeout(button.awCopiedTimer);
      button.awCopiedTimer = setTimeout(() => {
        button.classList.remove('is-copied');
        if (label) label.textContent = label.dataset.awText;
      }, 2200);
    };
    // If the browser blocks copying, select the code so it can be copied by hand
    const select = () => {
      const value = button.parentElement.querySelector('[data-aw-copy-value]') || button;
      const range = document.createRange();
      range.selectNodeContents(value);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(button.dataset.awCopy).then(copied, select);
    else select();
  });
})();
